import { HTTP } from '../../http-common'

export default {
  state: {
    loadedWatchdogSystems: []
  },
  getters: {
    loadedWatchdogSystems (state) {
      return state.loadedWatchdogSystems
    }
  },
  mutations: {
    setLoadedWatchdogSystems (state, payload) {
      state.loadedWatchdogSystems = payload
    },
    createWatchdogSystem (state, payload) {
      state.loadedWatchdogSystems.push(payload)
    },
    updateWatchdogSystem (state, payload) {
      state.loadedWatchdogSystems = state.loadedWatchdogSystems.map(watchdogSystem => watchdogSystem.id === payload.id ? payload : watchdogSystem)
    },
    removeWatchdogSystem (state, id) {
      state.loadedWatchdogSystems = state.loadedWatchdogSystems.filter(watchdogSystem => {
        return watchdogSystem.id !== id
      })
    },
    clearLoadedWatchdogSystems (state) {
      state.loadedWatchdogSystems = []
    }
  },
  actions: {
    loadWatchdogSystems ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedWatchdogSystems', [])

      return new Promise((resolve, reject) => {
        HTTP.get('watchdog_system_type.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedWatchdogSystems', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createWatchdogSystem ({ commit, getters }, payload) {
      console.log('createWatchdogSystem')
      commit('clearError')
      commit('setLoading', true)
      const newWatchdogSystem = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('watchdog_system_type.json/', newWatchdogSystem)
          .then(result => {
            console.log(result)
            commit('createWatchdogSystem', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateWatchdogSystem ({ commit, getters }, payload) {
      console.log('updateWatchdogSystem')
      commit('clearError')
      commit('setLoading', true)
      const watchdogSystem = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`watchdog_system_type.json/${payload.id}/`, watchdogSystem)
          .then(result => {
            console.log(result)
            commit('updateWatchdogSystem', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeWatchdogSystem ({ commit }, payload) {
      console.log('removeWatchdogSystem')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`watchdog_system_type.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeWatchdogSystem', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedWatchdogSystems ({ commit }) {
      commit('clearLoadedWatchdogSystems')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/watchdog_system/index.js